var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.job && _vm.steps)?_c('ExecutionHistory',{key:_vm.job.id,attrs:{"workflowId":_vm.job.workflowId,"processingOption":_vm.processingOption,"workflowType":_vm.WorkflowType.DataCheckin}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }